import { Table, TableBody, TableHead, TableRow } from "@mui/material";

import MDBox from "@/components/atoms/MDBox";
import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import useOrderData from "@/hooks/data/use-orders-data";
import { IOrder } from "@/interfaces/order.interfaces";
import { OrderItemListMessages } from "@/messages/order-details/order-Item-list.messages";
import borders from "@/themes/base/borders";
import colors from "@/themes/base/colors";
import typography from "@/themes/base/typography";

import { ITEMS_TABLE_COLUMNS } from "../../../../constants";

type Props = {
  messages: OrderItemListMessages;
  order: IOrder | null;
};

interface Item {
  skuCode: string;
  description: string;
  quantity: number;
  formattedGrossUnitPrice: string;
  formattedNetLineAmount: string;
  userComment?: string | null;
}

export default function OrderItemList({ messages, order }: Props) {
  const { formattedItems, hasItemsWithComments } = useOrderData({ order });
  const { size } = typography;
  const { borderWidth } = borders;
  const { light } = colors;

  const showCommentColumn = hasItemsWithComments || false;
  const columns = ITEMS_TABLE_COLUMNS(messages, showCommentColumn);

  const renderRow = (item: Item, field: keyof Item) => (
    <MDBox
      textAlign="left"
      component="td"
      py={2.5}
      px={1.8}
      sx={{
        fontSize: size.sm,
        borderBottom: `${borderWidth[1]} solid ${light.main}`,
      }}
    >
      <MDBox color={"dark"} sx={{ fontFamily: "var(--font-roboto) !important" }}>
        {item[field] ?? "-"}
      </MDBox>
    </MDBox>
  );

  return (
    <TableContainer>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableHeaderRow>
            {columns.map((label, index) => (
              <HeaderTableCell key={`${index} - ${label}`} width={"16%"}>
                {label}
              </HeaderTableCell>
            ))}
          </TableHeaderRow>
        </TableHead>
        <TableBody>
          {formattedItems.map((item, index) => (
            <TableRow key={index}>
              {renderRow(item, "skuCode")}
              {renderRow(item, "description")}
              {showCommentColumn && renderRow(item, "userComment")}
              {renderRow(item, "quantity")}
              {renderRow(item, "formattedGrossUnitPrice")}
              {renderRow(item, "formattedNetLineAmount")}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
